'use client';

import GlobalContextProvider from './global-context-provider';
import { UserProfileProvider } from './user-profile-context';
import { InstalledExtensionsProvider } from './installed-extensions-context';
import { ElectronDownloadProvider } from './electron-download-context';

interface Props {
  children: React.ReactNode;
  config: any;
}

// -----------------------------------------------------------------------------
// Aggregates the app-wide context providers so the root layout stays clean.
// Add new global providers here rather than nesting them in layout.tsx.
const AppProviders = (props: Props): JSX.Element => {
  const { config, children } = props;
  return (
    <GlobalContextProvider config={config}>
      <UserProfileProvider>
        <InstalledExtensionsProvider>
          <ElectronDownloadProvider>{children}</ElectronDownloadProvider>
        </InstalledExtensionsProvider>
      </UserProfileProvider>
    </GlobalContextProvider>
  );
};

export default AppProviders;
